<template>
  <div class="login">
    <div class="headers1">
      <img src="../../../static/images/logo.png" class="" alt />
    </div>
    <!-- <div class="headers2">
        <img src="../../../static/images/shlogo.png" class="" alt />
    </div> -->
    <img src="../../../static/images/bgs.jpg" class="bgs" alt />
    <img src="../../../static/images/gk.png" class="gk" alt />
    <!-- <img src="../../../static/images/1.png" class="bgs" alt />
    <img src="../../../static/images/logo.png" class="headers" alt /> -->
    <div class="login-body">
      <div class="login-form">
        <div class="loginbox">
          <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2">
            <div class="tt">医学虚拟仿真</div>
            <div class="tt1">实验教学系统</div>
            <!-- <h1>共克时艰版</h1> -->
            <el-form-item prop="username" class="form-group">
              <label class="iconfont nameicon"></label>

              <el-input
                v-model="ruleForm2.username"
                placeholder="请输入登录名"
                @keyup.enter.native="handleLoginClick"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password" class="form-group">
              <label class="iconfont mimaicon"></label>
              <el-input
                v-model="ruleForm2.password"
                placeholder="请输入密码"
                type="password"
                @keyup.enter.native="handleLoginClick"
              ></el-input>
            </el-form-item>

            <el-form-item class="form-group" prop="verification">
              <label class="iconfont yzmicon"></label>
              <el-input
                v-model="ruleForm2.verification"
                placeholder="请输入验证码"
                style="width: 60%;"
                @keyup.enter.native="handleLoginClick"
              ></el-input>
              <img :src="verifyImg" alt class="verifyImg" @click="getcode()" />
            </el-form-item>

            <button
              type="button"
              name="button"
              class="loginBtn"
              :disabled="loginSubmitting"
              :aria-busy="loginSubmitting"
              @click="handleLoginClick"
            >
              <i v-if="loginSubmitting" class="el-icon-loading login-loading-icon"></i>
              <span>{{ loginSubmitting ? "登录中..." : "登 录" }}</span>
            </button>
            <div class="register-entry">
              没有账号？
              <el-button type="text" @click="openRegisterDialog"
                >立即注册</el-button
              >
            </div>
            <p
              v-if="registrationNotice"
              class="registration-notice"
              role="status"
            >
              {{ registrationNotice }}
            </p>
          </el-form>
        </div>
        <el-dialog
          title="注册账号"
          :visible.sync="dialogFormVisible"
          class="register-dialog"
          width="500px"
          append-to-body
          :close-on-click-modal="false"
          :close-on-press-escape="!registerSubmitting"
          :show-close="!registerSubmitting"
          @closed="handleRegisterDialogClosed"
        >
          <el-form
            :model="register"
            :rules="registerRule"
            ref="registerForm"
            label-width="88px"
            status-icon
          >
            <el-form-item
              label="姓名"
              prop="realname"
              :error="registerErrors.realname"
            >
              <el-input
                v-model.trim="register.realname"
                placeholder="请输入姓名"
                autocomplete="name"
                @input="clearRegisterError('realname')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="用户名"
              prop="username"
              :error="registerErrors.username"
            >
              <el-input
                v-model.trim="register.username"
                placeholder="请输入用户名"
                autocomplete="username"
                @input="clearRegisterError('username')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="密码"
              prop="password"
              :error="registerErrors.password"
            >
              <el-input
                v-model="register.password"
                type="password"
                placeholder="请输入密码"
                autocomplete="new-password"
                show-password
                @input="handleRegisterPasswordInput"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="确认密码"
              prop="confirmPassword"
              :error="registerErrors.confirmPassword"
            >
              <el-input
                v-model="register.confirmPassword"
                type="password"
                placeholder="请再次输入密码"
                autocomplete="new-password"
                show-password
                @input="clearRegisterError('confirmPassword')"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="手机号"
              prop="mobile"
              :error="registerErrors.mobile"
            >
              <el-input
                v-model.trim="register.mobile"
                placeholder="请输入手机号"
                maxlength="11"
                autocomplete="tel"
                :disabled="registerCodeSending || codeCountdown > 0"
                @input="handleRegisterMobileInput"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="验证码"
              prop="code"
              :error="registerErrors.code"
            >
              <div class="register-code-row">
                <el-input
                  v-model.trim="register.code"
                  placeholder="请输入6位验证码"
                  maxlength="6"
                  autocomplete="one-time-code"
                  @input="clearRegisterError('code')"
                ></el-input>
                <el-button
                  class="register-code-button"
                  type="primary"
                  plain
                  :loading="registerCodeSending"
                  :disabled="registerCodeSending || codeCountdown > 0"
                  @click="sendRegisterCode"
                  >{{ registerCodeButtonText }}</el-button
                >
              </div>
              <div
                v-if="registerCodeTip"
                class="register-code-tip"
                role="status"
              >
                {{ registerCodeTip }}
              </div>
            </el-form-item>
            <el-form-item
              v-if="registerErrors.form"
              class="register-form-error-item"
              :error="registerErrors.form"
            >
              <span aria-hidden="true">&nbsp;</span>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              :disabled="registerSubmitting"
              @click="dialogFormVisible = false"
              >取 消</el-button
            >
            <el-button
              type="primary"
              :loading="registerSubmitting"
              @click="submitRegister('registerForm')"
              >注 册</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="login-footer">
      <p>
        技术支持单位：北京众绘虚拟现实技术研究院有限公司 联系电话：01060496324
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    var validateUserName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名 / 手机号码"));
      } else {
        callback();
      }
    };
    var validateRegisterMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var validateRegisterPasswordConfirm = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.register.password) {
        callback(new Error("密码不一致"));
      } else {
        callback();
      }
    };
    return {
      verifyImg: "",
      key: "",
      loginSubmitting: false,
      loginDebounceTimer: null,
      dialogFormVisible: false,
      registrationNotice: "",
      registerSubmitting: false,
      registerCodeSending: false,
      codeCountdown: 0,
      registerSessionId: 0,
      registerCodeTimer: null,
      registerCodeTip: "",
      register: {
        username: "",
        realname: "",
        mobile: "",
        code: "",
        password: "",
        confirmPassword: ""
      },
      registerErrors: {
        username: "",
        realname: "",
        mobile: "",
        code: "",
        password: "",
        confirmPassword: "",
        form: ""
      },
      ruleForm2: {
        username: "",
        password: "",
        verification: ""
      },
      registerRule: {
        username: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        realname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [
          {
            required: true,
            validator: validateRegisterMobile,
            trigger: "blur"
          }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            pattern: /^\d{6}$/,
            message: "请输入6位数字验证码",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        confirmPassword: [
          {
            required: true,
            validator: validateRegisterPasswordConfirm,
            trigger: "blur"
          }
        ]
      },

      rules2: {
        username: [{ validator: validateUserName, trigger: "blur" }],
        password: [{ validator: validatePass, trigger: "blur" }],
        verification: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "验证码格式不正确", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    registerCodeButtonText() {
      if (this.registerCodeSending) {
        return "发送中";
      }
      if (this.codeCountdown > 0) {
        return this.codeCountdown + "秒后重试";
      }
      return "获取验证码";
    }
  },

  methods: {
    openRegisterDialog() {
      this.registerSessionId += 1;
      this.registrationNotice = "";
      this.resetRegisterErrors();
      this.registerCodeTip = "";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs.registerForm) {
          this.$refs.registerForm.clearValidate();
        }
      });
    },
    handleRegisterDialogClosed() {
      this.registerSessionId += 1;
      this.stopRegisterCodeCountdown();
      this.registerCodeTip = "";
      this.registerSubmitting = false;
      this.registerCodeSending = false;
      this.resetRegisterErrors();
      if (this.$refs.registerForm) {
        this.$refs.registerForm.resetFields();
        this.$refs.registerForm.clearValidate();
      }
    },
    resetRegisterErrors() {
      this.registerErrors = {
        username: "",
        realname: "",
        mobile: "",
        code: "",
        password: "",
        confirmPassword: "",
        form: ""
      };
    },
    clearRegisterError(field) {
      if (
        Object.prototype.hasOwnProperty.call(this.registerErrors, field) &&
        this.registerErrors[field]
      ) {
        this.registerErrors[field] = "";
      }
      this.registerErrors.form = "";
      if (field === "mobile") {
        this.registerCodeTip = "";
      }
    },
    handleRegisterMobileInput() {
      this.clearRegisterError("mobile");
      this.register.code = "";
      this.registerErrors.code = "";
      this.registerCodeTip = "";
      this.stopRegisterCodeCountdown();
      if (this.$refs.registerForm) {
        this.$nextTick(() => {
          this.$refs.registerForm.clearValidate("code");
        });
      }
    },
    handleRegisterPasswordInput() {
      this.clearRegisterError("password");
      if (
        this.register.confirmPassword &&
        this.$refs.registerForm
      ) {
        this.$nextTick(() => {
          this.$refs.registerForm.validateField("confirmPassword");
        });
      }
    },
    sendRegisterCode() {
      if (
        this.registerCodeSending ||
        this.codeCountdown > 0 ||
        !this.$refs.registerForm
      ) {
        return;
      }
      this.registerErrors.mobile = "";
      this.registerErrors.form = "";
      this.registerCodeTip = "";
      var sessionId = this.registerSessionId;
      this.$refs.registerForm.validateField("mobile", errorMessage => {
        if (errorMessage) {
          return;
        }
        this.registerCodeSending = true;
        this.$http
          .sendRegisterCode({ mobile: this.register.mobile })
          .then(res => {
            if (sessionId !== this.registerSessionId) {
              return;
            }
            this.registerCodeSending = false;
            if (res && res.code == 200) {
              this.registerCodeTip = "验证码已发送，请注意查收";
              this.startRegisterCodeCountdown();
            } else {
              this.registerErrors.mobile = this.getRegisterResponseMessage(
                res,
                "验证码发送失败，请稍后重试"
              );
            }
          })
          .catch(error => {
            if (sessionId !== this.registerSessionId) {
              return;
            }
            this.registerCodeSending = false;
            this.registerErrors.mobile = this.getRegisterRequestError(
              error,
              "验证码发送失败，请稍后重试"
            );
          });
      });
    },
    startRegisterCodeCountdown() {
      this.stopRegisterCodeCountdown();
      this.codeCountdown = 60;
      this.registerCodeTimer = setInterval(() => {
        if (this.codeCountdown <= 1) {
          this.stopRegisterCodeCountdown();
          return;
        }
        this.codeCountdown -= 1;
      }, 1000);
    },
    stopRegisterCodeCountdown() {
      if (this.registerCodeTimer) {
        clearInterval(this.registerCodeTimer);
        this.registerCodeTimer = null;
      }
      this.codeCountdown = 0;
    },
    getRegisterResponseMessage(res, fallback) {
      return res && res.message ? res.message : fallback;
    },
    getRegisterRequestError(error, fallback) {
      var message =
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
          ? error.response.data.message
          : error && error.message
          ? error.message
          : fallback;
      return String(message).replace(/<br\s*\/?>/gi, " ");
    },
    formatRegisterFieldError(error) {
      return Array.isArray(error) ? error.join("；") : String(error);
    },
    applyRegisterResponseErrors(res) {
      var errors =
        res && (res.errors || (res.data && res.data.errors))
          ? res.errors || res.data.errors
          : null;
      var fields = [
        "username",
        "realname",
        "mobile",
        "code",
        "password",
        "confirmPassword"
      ];
      var hasFieldError = false;
      if (errors) {
        fields.forEach(field => {
          if (errors[field]) {
            this.registerErrors[field] = this.formatRegisterFieldError(
              errors[field]
            );
            hasFieldError = true;
          }
        });
      }
      if (!hasFieldError) {
        this.registerErrors.form = this.getRegisterResponseMessage(
          res,
          "注册失败，请检查填写信息"
        );
      }
    },
    submitRegister(formName) {
      if (this.registerSubmitting) {
        return;
      }
      this.resetRegisterErrors();
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return;
        }
        this.registerSubmitting = true;
        var sessionId = this.registerSessionId;
        var params = {
          code: this.register.code,
          mobile: this.register.mobile,
          username: this.register.username,
          password: this.register.password,
          realname: this.register.realname
        };
        this.$http
          .userRegister(params)
          .then(res => {
            if (sessionId !== this.registerSessionId) {
              return;
            }
            this.registerSubmitting = false;
            if (res.code == 200) {
              this.ruleForm2.username = this.register.username;
              this.registrationNotice = "注册成功，请使用新账号登录";
              this.$message.success("注册成功！");
              this.dialogFormVisible = false;
            } else {
              this.applyRegisterResponseErrors(res);
            }
          })
          .catch(error => {
            if (sessionId !== this.registerSessionId) {
              return;
            }
            this.registerSubmitting = false;
            if (error && error.response && error.response.data) {
              this.applyRegisterResponseErrors(error.response.data);
            } else {
              this.registerErrors.form = this.getRegisterRequestError(
                error,
                "注册失败，请稍后重试"
              );
            }
          });
      });
    },

    handleLoginClick() {
      if (this.loginSubmitting) {
        return;
      }
      if (this.loginDebounceTimer) {
        clearTimeout(this.loginDebounceTimer);
      }
      this.loginDebounceTimer = setTimeout(() => {
        this.loginDebounceTimer = null;
        this.submitForm("ruleForm2");
      }, 300);
    },
    changeCodeImg: function() {
      this.verifyImg = "/wkt-pcapis/login/image?r=" + Math.random();
    },
    submitForm(formName) {
      if (this.loginSubmitting) {
        return;
      }
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loginSubmitting = true;
          this.validateCode();
          return;
        } else {
          this.loginSubmitting = false;
          this.$message.error("账号和密码不能为空");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    resetLoginAfterFailure() {
      this.loginSubmitting = false;
      this.ruleForm2.verification = "";
      this.getcode();
    },

    loginHandler() {
      var params = {
        username: this.$Base64.encode(this.ruleForm2.verification),
        password: this.$Base64.encode(this.key),
        captcha:
          Math.random()
            .toString(36)
            .slice(2) +
          "captcha" +
          this.$Base64.encode(this.ruleForm2.username),
        key:
          Math.random()
            .toString(36)
            .slice(2) +
          "key" +
          this.$Base64.encode(this.ruleForm2.password)
      };
      var data = this.$Base64.encode(JSON.stringify(params));
      this.$http
        .userLogin({ data: data })
        .then(res => {
          if (res.code == 200) {
            for (let key in res.data) {
              this.$cookies.set(key, res.data[key]);
            }
            this.getUserInfo();
          } else {
            this.resetLoginAfterFailure();
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.resetLoginAfterFailure();
          console.log(err);
        });
    },
    checkLogin() {
      if (this.$cookies.get("token")) {
        this.$router.push({ name: "myInfo" });
      }
    },
    getUserInfo() {
      this.$http.getUserInfo({ id: this.$cookies.get("id") }).then(res => {
        if (res.code !== 0) {
          this.loginSubmitting = false;
          // 分发actions中getUserInfo方法  找store/index.js
          this.$store.dispatch("SetUserInfo", res.data);
          //返回之前的前面
          this.$router.push(
            this.$route.params.redirect
              ? { path: this.$route.params.redirect }
              : { name: "practiceList" }
          );
        } else {
          this.resetLoginAfterFailure();
          this.$message.error(res.message);
        }
      }).catch(err => {
        this.resetLoginAfterFailure();
        console.log(err);
      });
    },
    //获取验证码
    getcode() {
      this.$http.getCode().then(res => {
        this.verifyImg = res.data.url.img;
        this.key = res.data.url.key;
      });
    },
    //验证验证码
    validateCode() {
      var params = {
        captcha: this.ruleForm2.verification,
        key: this.key
      };
      this.$http
        .validateCode(params)
        .then(res => {
          if (res.code == 200) {
            this.loginHandler();
          } else {
            this.resetLoginAfterFailure();
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.resetLoginAfterFailure();
          console.log(err);
        });
    }
  },
  beforeDestroy() {
    if (this.loginDebounceTimer) {
      clearTimeout(this.loginDebounceTimer);
      this.loginDebounceTimer = null;
    }
    this.registerSessionId += 1;
    this.stopRegisterCodeCountdown();
  },
  created() {
    this.checkLogin();
    this.getcode();
  }
};
</script>
<style lang="less">
body,
html {
  margin: 0;
  padding: 0;
  // background: #4e546c;
  height: 100%;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-weight: 400;
  overflow: hidden !important;
  -webkit-font-smoothing: antialiased;
}
#app {
  height: 100%;
  min-height: 100%;
  overflow-y: auto;
}
.bgs {
  width: 100%;
  height: 100vh;
  position: absolute;
}
.headers {
  position: absolute;
  left: 20px;
  top: 1%;
  height: 5%;
}
input::-webkit-input-placeholder {
  color: #a7b6c3;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #a7b6c3;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #a7b6c3;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #a7b6c3;
}

.login {
  position: relative;
  .el-checkbox__label {
    display: inline-block;
    padding-left: 10px;
    line-height: 19px;
    font-size: 14px;
  }
  .el-checkbox__inner {
    border: 2px solid #237fcc;
  }
  // background-color: #4e546c;
  // background-image: -webkit-linear-gradient(top, #5cbcfc,#3487ff);
  //background: url("../../../static/images/1.png") no-repeat;

  height: 100vh;
  // height: calc(100% - 80px);
  background-size: 100%, 100%;
  overflow: hidden;
  overflow-y: auto;
  .login-header {
    /*background-color: #fff;*/
    height: 100px;
    .zlyun {
      height: 60px;
      margin-left: 44px;
      margin-right: 23px;
      padding-top: 30px;
    }
    .zlysxy {
      width: 217px;
      height: 34px;
    }
  }
  .login-body {
    position: relative;
    // min-height: 650px;
    height: calc(100%);
    .loginleftImg {
      position: absolute;
      width: 34%;
      left: 10%;
      top: 50%;
      transform: translate(0, -50%);
      min-width: 450px;
    }

    .login-form {
      position: absolute;
      left: 10%;
      top: 31%;
      width: 25%;

      padding-bottom: 20px;
      min-width: 300px;
      max-width: 400px;
      // height: 600px;
      background-color: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 160, 233, 0.5);
      border-radius: 8px;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
      }
      .loginbox {
        position: relative;
        form {
          .el-form-item__error {
            color: #ff4401;
            line-height: 30px;
            padding-top: 4px;
            position: absolute;
            top: 40px;
            left: 53px;
            height: 30px;
            background-color: #ffc7b2;
            border-radius: 4px;
            border: solid 1px #ff4401;
            font-size: 14px;
            padding: 0 10px;
            box-sizing: border-box;
            z-index: 10;
            &:after {
              content: "";
              position: absolute;
              width: 18px;
              height: 18px;
              top: 9px;
              left: 10px;
            }
            &:before {
              content: "";
              position: absolute;
              width: 12px;
              height: 6px;
              top: -5px;
              left: 12px;
            }
          }
          padding: 0 6%;
          .tt {
            font-size: 18px;
            text-align: center;
            padding-top: 20px;
            font-weight: bold;
          }
          .tt1 {
            font-size: 18px;
            text-align: center;
            padding-top: 4px;
            padding-bottom: 20px;

            font-weight: bold;
          }
          h1 {
            text-align: center;
            margin: 16px 0 16px 0;
            // font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            color: #282b29;
            line-height: 1;
          }
          .form-group {
            width: 100%;
            margin: 0 auto;
            margin-bottom: 16px;
            position: relative;

            label {
              position: absolute;
              top: 50%;
              margin-top: -11px;
              left: 14px;
              margin-right: 10px;
              z-index: 99;
              width: 20px;
              height: 22px;
              display: inline-block;
            }
            .nameicon {
              &:before {
                position: absolute;
                width: 20px;
                height: 22px;
                content: "";
                background: url("../../../static/images/user.png") no-repeat;

                background-size: 20px 22px;
              }
            }
            .mimaicon {
              &:before {
                position: absolute;
                width: 20px;
                height: 22px;
                content: "";
                background: url("../../../static/images/password.png") no-repeat;
                background-size: 20px 22px;
              }
            }
            .yzmicon {
              &:before {
                position: absolute;
                width: 20px;
                height: 22px;
                content: "";
                background: url("../../../static/images/yzcode.png") no-repeat;
                background-size: 20px 22px;
              }
            }
            p {
              margin: 0;
              position: absolute;
              top: 50%;
              margin-top: -14px;

              right: 14px;
              z-index: 99;
              i {
                font-size: 26px;
                color: #a7b6c3;
              }
              .icon-yanjing {
                color: #237fcc;
              }
            }
            .ischange {
              width: 28px;
              height: 20px;
            }
            input {
              height: 45px;
              width: 100%;
              color: #a7b6c3;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: none;

              font-size: 14px;
              border-radius: 4px;
            }
            .el-input__inner {
              border: solid 2px #d2d2d2;
              padding-left: 40px;
            }
            .verifyImg {
              width: 35%;
              height: 45px;
              background: #a7b6c3;
              position: absolute;
              right: 0;
              top: 0;
              border-radius: 4px;
            }
          }
          .el-checkbox {
            color: #237fcc;
          }
          .checkInfo {
            margin-bottom: 36px;
            .el-checkbox__input.is-checked .el-checkbox__inner,
            .el-checkbox__input.is-indeterminate .el-checkbox__inner {
              background-color: #237fcc;
            }

            .el-checkbox__input.is-checked + .el-checkbox__label {
              font-size: 14px;
              color: #237fcc;
            }
          }
          .loginBtn {
            font-family: MicrosoftYaHei;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            outline: none;
            cursor: pointer;
            font-size: 20px;

            box-sizing: border-box;
            -webkit-box-sizing: border-box;
            height: 40px;
            // background-color: #237fcc;
            border-radius: 40px;
            background-image: linear-gradient(to right, #4994ff, #72acff);
            border: none;
            &:disabled {
              cursor: not-allowed;
              opacity: 0.72;
            }
            .login-loading-icon {
              margin-right: 8px;
              font-size: 16px;
            }
          }
          .el-form-item.is-success .el-input__inner,
          .el-form-item.is-success .el-input__inner:focus,
          .el-form-item.is-success .el-textarea__inner,
          .el-form-item.is-success .el-textarea__inner:focus {
            border-color: #4c94fd !important;
          }
          .el-form-item.is-error .el-input__inner,
          .el-form-item.is-error .el-input__inner:focus,
          .el-form-item.is-error .el-textarea__inner,
          .el-form-item.is-error .el-textarea__inner:focus,
          .el-message-box__input input.invalid,
          .el-message-box__input input.invalid:focus {
            border-color: #4c94fd !important;
          }
          .el-form-item.is-success label {
            color: #4c94fd;
          }
          .el-form-item.is-success .nameicon {
            &:before {
              position: absolute;
              width: 24px;
              height: 26px;
              content: "";
              background-size: 24px 26px;
            }
          }
          .el-form-item.is-success .mimaicon {
            &:before {
              position: absolute;
              width: 24px;
              height: 26px;
              content: "";
              background-size: 24px 26px;
            }
          }
          .el-form-item.is-success .yzmicon {
            &:before {
              position: absolute;
              width: 24px;
              height: 26px;
              content: "";
              background-size: 24px 26px;
            }
          }
        }
      }
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #237fcc;
      border-color: #237fcc;
    }
  }
  .btnbg {
    width: 100%;
  }
  .login-footer {
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #4e546c;
    background: #fff;
    position: fixed;
    bottom: 0;
    p {
      margin-top: 0;
    }
  }
  .register-entry {
    margin-top: 12px;
    color: #7d8b99;
    font-size: 14px;
    text-align: center;
    .el-button {
      padding: 0;
      font-size: 14px;
    }
  }
  .registration-notice {
    margin: 8px 0 0;
    color: #67c23a;
    font-size: 13px;
    line-height: 20px;
    text-align: center;
  }
}
.register-dialog {
  .el-dialog {
    max-width: calc(100vw - 30px);
    border-radius: 8px;
  }
  .el-dialog__body {
    padding: 24px 32px 6px;
  }
  .register-code-row {
    display: flex;
    align-items: center;
    .el-input {
      flex: 1;
    }
  }
  .register-code-button {
    width: 120px;
    margin-left: 10px;
  }
  .register-code-tip {
    color: #67c23a;
    font-size: 12px;
    line-height: 20px;
  }
  .register-form-error-item {
    margin-top: -8px;
    margin-bottom: 4px;
    .el-form-item__content {
      min-height: 20px;
    }
  }
}
@media screen and (max-width: 600px) {
  .register-dialog {
    .el-dialog__body {
      padding-right: 18px;
      padding-left: 18px;
    }
    .register-code-row {
      align-items: stretch;
    }
    .register-code-button {
      width: 108px;
    }
  }
}
@media screen and (max-width: 1000px) {
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
}

@media screen and (min-width: 1200px) and (max-width: 1300px) {
}

@media screen and (min-width: 1300px) and (max-width: 1460px) {
}
@media screen and (min-width: 1460px) {
}
</style>
<style lang="css" scoped>
.box {
  width: 100%;
  position: relative;
}
.box img {
  width: 100%;
}
.box .login {
  position: absolute;
  width: 500px;
  height: 400px;
  top: 50%;
  left: 50%;
  margin-left: -250px;
  margin-top: -300px;
}
.login .login-title {
  width: 100%;
  text-align: center;
}
.login-title img {
  width: 190px;
  height: auto;
}
.login-title p {
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #fff;
  letter-spacing: 0.29px;
  padding-top: 10px;
  padding-bottom: 50px;
}
.login_box {
  width: 400px;
  height: auto;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  margin: 0 auto;
  padding-bottom: 40px;
}
.login_box .title {
  font-size: 20px;
  color: #9b9b9b;
  letter-spacing: 0.32px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  justify-content: space-around;
  padding: 50px 60px 0 60px;
  margin-bottom: 20px;
  cursor: pointer;
}
.login_box .title span:nth-of-type(1) {
  color: #4a4a4a;
  border-bottom: 2px solid #84cc39;
}

.inp {
  width: 350px;
  margin: 0 auto;
}
.inp input {
  border: 0;
  outline: 0;
  width: 100%;
  height: 45px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  text-indent: 20px;
  font-size: 14px;
  background: #fff !important;
}
.inp input.user {
  margin-bottom: 16px;
}
.inp .rember {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 10px;
}
.inp .rember p:first-of-type {
  font-size: 12px;
  color: #4a4a4a;
  letter-spacing: 0.19px;
  margin-left: 22px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  /*position: relative;*/
}
.inp .rember p:nth-of-type(2) {
  font-size: 14px;
  color: #9b9b9b;
  letter-spacing: 0.19px;
  cursor: pointer;
}

.inp .rember input {
  outline: 0;
  width: 30px;
  height: 45px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  text-indent: 20px;
  font-size: 14px;
  background: #fff !important;
}

.inp .rember p span {
  display: inline-block;
  font-size: 12px;
  width: 100px;
  /*position: absolute;*/
  /*left: 20px;*/
}
#geetest {
  margin-top: 20px;
}
.login_btn {
  width: 100%;
  height: 45px;
  background: #0980cc;
  border-radius: 5px;
  font-size: 16px;
  color: #fff;
  letter-spacing: 0.26px;
  margin-top: 30px;
}
.inp .go_login {
  text-align: center;
  font-size: 14px;
  color: #9b9b9b;
  letter-spacing: 0.26px;
  padding-top: 20px;
}
.inp .go_login span {
  color: #84cc39;
  cursor: pointer;
}
.headers1 {
  height: 50px;
  background: #fff;
  position: absolute;
  z-index: 11;
  top: 0;
  width: 100%;
}
.headers1 img {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  height: 30px;
}
.headers2 {
  /* height:50px; */
  /* background: #fff; */
  position: relative;
  z-index: 11;
  top: 0;
  width: 100%;
}
.headers2 img {
  position: absolute;
  top: 10px;

  left: 24px;
  height: 80px;
}
.gk {
  position: absolute;

  z-index: 11;
  left: 10%;
  top: 19%;
  height: 80px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue